// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vuex from 'vuex'
import store from './store/index'
import VueSession from 'vue-session'
import axios from 'axios';
import firebase from 'firebase'
import VueJwtDecode from 'vue-jwt-decode'
import VueCarousel from 'vue-carousel';
import es from 'vuetify/es5/locale/es'

Vue.use(VueCarousel);




var options = {
  persist: true
}

Vue.use(VueSession, options)
Vue.use(Vuex)


Vue.use(Vuetify,
  {
    lang: {
      locales: { es },
      current: 'es'
    }
  }
)
Vue.use(Vuelidate)
Vue.use(VueJwtDecode)

const config = {
  apiKey: "AIzaSyD6vdtoPrzVxZmQkJ61LM8HGYdAoUiz1a8",
  authDomain: "fir-3de9d.firebaseapp.com",
  databaseURL: "https://fir-3de9d.firebaseio.com",
  projectId: "fir-3de9d",
  storageBucket: "fir-3de9d.appspot.com",
  messagingSenderId: "393191665670",
  appId: "1:393191665670:web:025150acd84cf964"
};
// Initialize Firebase
firebase.initializeApp(config);

Vue.use(firebase)



Vue.config.productionTip = false
Vue.prototype.$http = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js